import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalvarsService {

  private userToken = new BehaviorSubject('');
  getToken = this.userToken.asObservable();

  constructor() { }

  storeToken(token: string) {
    this.userToken.next(token);
  }
}
